import { render, staticRenderFns } from "./formattedInspectionStatus.vue?vue&type=template&id=23a7da74"
import script from "./formattedInspectionStatus.vue?vue&type=script&lang=js"
export * from "./formattedInspectionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports